import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import React, { PureComponent } from "react";
import Search from "@material-ui/icons/Search";
import Settings from "@material-ui/icons/Settings";
import { Route, generatePath } from "react-router-dom";
import Visibility from "@material-ui/icons/Visibility";
import VerticalSplit from "@material-ui/icons/VerticalSplit";

import { toggleModal } from "altus-modal";
import { HeaderBase, LogoAndAppTitle } from "altus-ui-components";

import {
  VIEW_SIDE_PANEL_ID,
  SEARCH_SIDE_PANEL_ID,
  CREATE_VIEW_GROUPS_MODAL_ID,
} from "features/planner/planner.constants";

import routePaths from "app/routePaths";
import { replacePanel } from "app/app.actions";
import { isPanelOpen } from "app/app.selectors";
import { logout } from "features/login/login.actions";
import UserDropdown from "app/components/UserDropdown";
import { APP_NAME, APP_ROLES } from "app/app.constants";
import AccessControl from "app/components/AccessControl";
import ViewTabs from "features/planner/components/View/ViewTabs";
import { VIEW_EDIT_MODE } from "features/planner/components/View/ViewContainer";
import ViewHeaderIconButton from "features/planner/components/View/ViewHeaderIconButton";

class ViewHeader extends PureComponent {
  render() {
    const {
      match,
      viewSidePanelOpen,
      searchSidePanelOpen,
      dispatchToggleModal,
      dispatchReplacePanel,
    } = this.props;

    const { mode, viewId } = match.params;

    const isEditMode = mode === VIEW_EDIT_MODE;

    return (
      <HeaderBase>
        <Grid container spacing={1}>
          <Grid item container xs spacing={1} alignItems="center">
            <LogoAndAppTitle title={APP_NAME} to={routePaths.root} />
          </Grid>
          <Grid item>
            <ViewTabs />
          </Grid>
          <Grid
            xs
            item
            container
            spacing={1}
            wrap="nowrap"
            justifyContent="flex-end"
            alignItems="center"
          >
            <AccessControl
              accessLevel={[
                APP_ROLES.ADMIN,
                APP_ROLES.PLANNER,
                APP_ROLES.VIEWER,
              ]}
            >
              <Route
                exact
                path={[routePaths.view]}
                render={() => (
                  <>
                    <Grid item>
                      <ViewHeaderIconButton
                        Icon={Add}
                        title="Add"
                        disabled={isEditMode}
                        ButtonProps={{
                          onClick: () =>
                            dispatchToggleModal({
                              modalId: CREATE_VIEW_GROUPS_MODAL_ID,
                            }),
                        }}
                      />
                    </Grid>
                    {viewId && (
                      <Grid item>
                        <ViewHeaderIconButton
                          title="Layout"
                          Icon={VerticalSplit}
                          selected={mode === "edit"}
                          to={
                            isEditMode
                              ? generatePath(routePaths.view, { viewId })
                              : generatePath(routePaths.view, {
                                  viewId,
                                  mode: VIEW_EDIT_MODE,
                                })
                          }
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <ViewHeaderIconButton
                        title="Views"
                        Icon={Visibility}
                        selected={viewSidePanelOpen}
                        disabled={isEditMode}
                        ButtonProps={{
                          onClick: () =>
                            dispatchReplacePanel(VIEW_SIDE_PANEL_ID),
                        }}
                      />
                    </Grid>
                    <AccessControl
                      accessLevel={[APP_ROLES.ADMIN, APP_ROLES.PLANNER]}
                    >
                      <Grid item>
                        <ViewHeaderIconButton
                          Icon={Search}
                          title="Search"
                          selected={searchSidePanelOpen}
                          disabled={isEditMode}
                          ButtonProps={{
                            onClick: () =>
                              dispatchReplacePanel(SEARCH_SIDE_PANEL_ID),
                          }}
                        />
                      </Grid>
                    </AccessControl>
                  </>
                )}
              />
            </AccessControl>
            <AccessControl accessLevel={[APP_ROLES.ADMIN, APP_ROLES.PLANNER]}>
              <Grid item>
                <ViewHeaderIconButton
                  Icon={Settings}
                  title="Settings"
                  to="/settings"
                />
              </Grid>
            </AccessControl>
            <Grid item>
              <UserDropdown />
            </Grid>
          </Grid>
        </Grid>
      </HeaderBase>
    );
  }
}
export default compose(
  connect(
    state => ({
      viewSidePanelOpen: isPanelOpen(state, VIEW_SIDE_PANEL_ID),
      searchSidePanelOpen: isPanelOpen(state, SEARCH_SIDE_PANEL_ID),
    }),
    {
      dispatchLogout: logout,
      dispatchToggleModal: toggleModal,
      dispatchReplacePanel: replacePanel,
    },
  ),
)(ViewHeader);
